import {
  Box,
  Paper,
  SimplePaletteColorOptions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { NoDataCoinStack, palette } from '@ankr.com/ui';

import { StatusCircle } from 'uiKit/StatusCircle';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { Country } from '../../types';
import { useStatsTableStyles } from './useStatsTableStyles';
import { statsTableTranslation } from './translation';

export interface StatsTableProps {
  data: Country[];
  dataType?: 'requests' | 'traffic';
  selectedCountry: string;
}

export const StatsTable = ({
  data,
  dataType = 'requests',
  selectedCountry,
}: StatsTableProps) => {
  const { classes, cx } = useStatsTableStyles();

  const { keys, t } = useTranslation(statsTableTranslation);

  return (
    <div className={classes.root}>
      <TableContainer component={Paper} className={classes.table} elevation={0}>
        <Box component={Table} minWidth={230}>
          <TableHead className={classes.thead}>
            <TableRow>
              <TableCell className={classes.cellThead}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  className={classes.subtitle2}
                >
                  {t(keys.country)}
                </Typography>
              </TableCell>
              <TableCell className={classes.cellThead}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  className={classes.subtitle2}
                >
                  {dataType === 'requests' ? t(keys.requests) : t(keys.volume)}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.body}>
            {data.map(country => {
              const { color, isoA2, name, requests } = country;

              const isSelectedCountry = selectedCountry === isoA2;

              return (
                <TableRow
                  key={name}
                  className={cx(
                    classes.row,
                    isSelectedCountry ? classes.selected : '',
                  )}
                >
                  <TableCell padding="none" className={classes.firstCell}>
                    <StatusCircle
                      mr={1.25}
                      color={
                        isSelectedCountry
                          ? (palette.primary as SimplePaletteColorOptions).main
                          : color
                      }
                    />
                    <Typography variant="body3" className={classes.name}>
                      {name}
                    </Typography>
                  </TableCell>
                  <TableCell padding="none" className={classes.secondCell}>
                    <Typography variant="body3" className={classes.requests}>
                      {requests}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Box>
        {data.length === 0 && (
          <div className={classes.noData}>
            <NoDataCoinStack />
            <Typography
              variant="body3"
              color="textSecondary"
              align="center"
              maxWidth={200}
            >
              {t(keys.noRequests)}
            </Typography>
          </div>
        )}
      </TableContainer>
    </div>
  );
};
